import axios from 'axios'
import qs from 'qs'

const baseURL = `${process.env.VUE_APP_NEW_API_URL}`

export default {
    getSummary(from, to) {
        try {
          return axios.get(`${baseURL}/payment-gateway`, {
              params: {
                  from,
                  to
              }
          })
        } catch (e) {
          throw e
        }
    },
    getDetail(id) {
        try {
            return axios.get(`${baseURL}/payment-gateway/${id}`)
        } catch (e) {
            throw e
        }
    },
    update(id, data) {
        try {
            return axios.patch(`${baseURL}/payment-gateway/${id}`, data)
        } catch (e) {
            throw e
        }
    },
    updateBalance(id, data) {
        try {
            return axios.patch(`${baseURL}/payment-gateway/${id}/balance`, data)
        } catch (e) {
            throw e
        }
    },
    getBalanceLogs(params) {
        try {
            return axios.get(`${baseURL}/payment-gateway/balance-log`, {
                params,
                // API รับ type หลายค่าคั่นด้วย comma
                paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'comma', skipNulls: true })
            })
        } catch (e) {
            throw e
        }
    },
    getBalanceLogActors() {
        try {
            return axios.get(`${baseURL}/payment-gateway/balance-log/actors`)
        } catch (e) {
            throw e
        }
    }
}
